module.exports = __webpack_public_path__ + "static/media/盈浦党建.c027bf94.jpg";